import { render, staticRenderFns } from "./RecentStarView.vue?vue&type=template&id=439e8b0a&scoped=true"
import script from "./RecentStarView.vue?vue&type=script&lang=js"
export * from "./RecentStarView.vue?vue&type=script&lang=js"
import style0 from "./RecentStarView.vue?vue&type=style&index=0&id=439e8b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e8b0a",
  null
  
)

export default component.exports